var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerIcon2Mob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4796 15.8242L25.5026 4.46948C25.328 3.46702 24.4672 2.76172 23.4956 2.76172C23.378 2.76172 6.18243 5.82129 6.18243 5.82129C5.07274 6.01946 4.33175 7.09112 4.52744 8.21491L4.71802 9.30958H20.2371C22.2059 9.30958 23.8077 10.9317 23.8077 12.9255V14.3744V17.8895V18.5779L25.8246 18.2178C26.9343 18.0196 27.6753 16.948 27.4796 15.8242Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2764 19.4414H1.36328V24.174C1.36328 25.3151 2.27678 26.2402 3.40358 26.2402H20.236C21.3629 26.2402 22.2764 25.3151 22.2764 24.174V19.4414ZM7.43761 24.3786H3.96655C3.54402 24.3786 3.20146 24.0317 3.20146 23.6038C3.20146 23.1759 3.54402 22.829 3.96655 22.829H7.43761C7.86014 22.829 8.2027 23.1759 8.2027 23.6038C8.2027 24.0317 7.86019 24.3786 7.43761 24.3786Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36719 12.8248H22.2752C22.2233 11.7305 21.3309 10.8594 20.2374 10.8594H3.40499C2.31153 10.8594 1.41907 11.7305 1.36719 12.8248Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36328 14.375H22.2764V17.8901H1.36328V14.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIcon2Mob);
export default __webpack_public_path__ + "static/media/banner_icon2mob.354d9ed47bf77b1fb359c2f174f522e5.svg";
export { ForwardRef as ReactComponent };